// extracted by mini-css-extract-plugin
module.exports = {"container":"Counter_container__2NgeY","counter":"Counter_counter__2d6O8"};